import { render, staticRenderFns } from "./ChiSiamo.vue?vue&type=template&id=7d78bc0d&scoped=true"
import script from "./ChiSiamo.vue?vue&type=script&lang=js"
export * from "./ChiSiamo.vue?vue&type=script&lang=js"
import style0 from "./ChiSiamo.vue?vue&type=style&index=0&id=7d78bc0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d78bc0d",
  null
  
)

export default component.exports